import jQuery from 'jquery';
window.jQuery = jQuery;

import select2 from 'select2';
select2(window, window.jQuery);

import DataTable from "datatables.net-bs5";
DataTable(window, window.jQuery);
